'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCompose;

var _redux = require('redux');

function getCompose() {
  return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/redux/getCompose.js
// module id = 526
// module chunks = 0